<mf-page title="Pasarelas">
  <mf-row>
    <mf-grid
      #grid
      actionButtonText="Nueva pasarela"
      [apiEndpoint]="apiEndpoint"
      [columns]="columns"
      [menuItems]="menuItems"
      [mustIncludeFields]="mustIncludeFields"
      (actionButtonClick)="openNewGatewayPopup()" />
  </mf-row>
</mf-page>
